/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import BasicQuoteInformation from '../../BasicQuoteInformation/BasicQuoteInformation';
import CrmQuote from '../../../../classes/CrmQuote';
import RegisterSignInBox from '../../../orders_quotes_shared/RegisterSignInBox/RegisterSignInBox';
import { generateResourceURLFromParam } from '../../../../utility/orderAndQuoteUtil';

function NotAuthenticateQuoteScreen({ quote, loadError }) {
  const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const forceSignInView = new URLSearchParams(location.search).get('ref') === 'login';
  const { id } = params;

  const onPayAsGuest = () => {
    /* istanbul ignore next */
    history.push(`/p/quote/pay-as-guest/QUO-${generateResourceURLFromParam(id)}`);
  };
  /* istanbul ignore next */
  return (
    <div>
      <div className="row">
        <div className="col-auto mb-2">
          <BasicQuoteInformation
            quoteNumber={quote.quoteNumber}
            quoteStatus={quote.statusType}
            createdAt={quote.createdAtDisplay}
            expiresAt={quote.expiresAtDisplay}
            loadError={loadError}
          />
        </div>
        {!loadError && (
          <div className="col-xs-12 col-sm-10 col-md-6 col-lg-5">
            <RegisterSignInBox
              referrer={`quo-${generateResourceURLFromParam(id)}`}
              isOrder={false}
              isClosed={quote.statusType && quote.statusType === 'Closed'}
              forceSignIn={forceSignInView}
              onPayAsGuest={onPayAsGuest}
              isPayable
            />
          </div>
        )}
      </div>
    </div>
  );
}

NotAuthenticateQuoteScreen.propTypes = {
  quote: PropTypes.shape(CrmQuote).isRequired,
  loadError: PropTypes.bool.isRequired,
};

export default NotAuthenticateQuoteScreen;
